import { useEffect } from 'react';

import { getLanguageKeysInForm } from '@components/form/dynamic-fields';
import { setLocale, useLocale } from '@locale/translate';

import { FormResponse } from 'api/form';

// We try to set the company default language as the locale but
// we need to see once the form is loaded, whether the company
// default language exists in the form itself. Otherwise just
// set the first language key found in the form.
export const useVerifyDefaultLocale = (form?: FormResponse['form']) => {
  const locale = useLocale();

  useEffect(() => {
    if (!form) return;

    const languageKeys = getLanguageKeysInForm(form);

    if (!languageKeys.includes(locale) && languageKeys.length > 0) {
      setLocale(languageKeys[0]);
    }
  }, [locale, form]);
};
